import { useMemo } from "react";
import { useTaskInitQuery } from "./useTaskInitQuery";

interface UseEntityLevelCustomAttributesOptions {
  entityId: string;
}

/**
 * Source of entity-level custom attributes like legacy custom fields and statuses.
 * Designed to provide backwards compatibility for existing entities and will be removed in the future.
 */
export const useEntityLevelCustomAttributes = ({
  entityId,
}: UseEntityLevelCustomAttributesOptions) => {
  const { data } = useTaskInitQuery({ entityId });

  const entityLevelCustomFields = useMemo(
    () => data?.customFieldsData.items || [],
    [data?.customFieldsData.items]
  );

  const entityLevelCustomStatuses = useMemo(
    () => data?.customStatuses || [],
    [data?.customStatuses]
  );

  return {
    entityLevelCustomFields,
    entityLevelCustomStatuses,
  };
};
